var _path, _path2, _ellipse, _ellipse2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle5, _path29, _path30, _path31, _circle6, _path32, _path33, _path34, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawWorkTogetherH63L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 740.302,
    height: 489.3,
    viewBox: "150 0 740.302 489.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M182.972.399h703.576V451H182.972z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M245.187 60.907h254v261h-254zM594.187 65.969h254v317h-254z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 844.802,
    cy: 477.262,
    rx: 45.5,
    ry: 6.5,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.9,
    cy: 477.407,
    rx: 45.5,
    ry: 6.5,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6841f",
    d: "M182.672 0h703.576v29.89H182.672z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204.884,
    cy: 15.282,
    r: 5.54,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.913,
    cy: 15.282,
    r: 5.54,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.941,
    cy: 15.282,
    r: 5.54,
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M792.187 150.999h-1.539v-42.15a24.396 24.396 0 00-24.395-24.397H676.95a24.396 24.396 0 00-24.396 24.396V340.09a24.396 24.396 0 0024.396 24.396h89.302a24.396 24.396 0 0024.395-24.396V181.002h1.539z",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M766.237 90.8H754.58a8.655 8.655 0 01-8.014 11.924h-51.16a8.656 8.656 0 01-8.013-11.925h-10.888a18.218 18.218 0 00-18.218 18.219V339.92a18.218 18.218 0 0018.218 18.218h89.732a18.218 18.218 0 0018.218-18.218V109.018a18.218 18.218 0 00-18.218-18.219z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M284.09 225.776h176.544v8.053H284.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6841f",
    d: "M284.09 251.776h176.544v8.053H284.09z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M284.09 277.776h176.544v8.053H284.09zM670.839 243.346h103.064v8.053H670.839zM670.839 268.346h103.064v8.053H670.839zM670.839 293.346h103.064v8.053H670.839z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M784.68 401.214v17.177h-17.178v-17.177z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6841f",
    d: "M757.005 401.213v17.177h-17.177v-17.177z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M729.33 401.214v17.177h-17.177v-17.177zM701.656 401.213v17.177h-17.177v-17.177zM673.981 401.214v17.177h-17.177v-17.177z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6841f",
    d: "M692.742 138.99H750v57.258h-57.258z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M349.605 275.593l-.74 1.482-2.224-11.117s-2.965-11.858 2.964-11.858 4.447 11.858 4.447 11.858v8.153zM446.846 274.075l.742 1.482 2.223-11.117s2.965-11.858-2.965-11.858-4.446 11.858-4.446 11.858v8.153z",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M382.215 358.94l-8.893 54.844 4.446 53.361 10.376-4.446-1.482-40.022 10.376-31.869 2.223 37.798-4.446 39.28 13.34 1.483 9.635-80.784-.741-27.422-34.834-2.223z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.215 460.475l-5.188 8.153v18.216a2.209 2.209 0 001.857 2.18c2.542.418 6.97.714 8.52-1.868 2.223-3.706.74-11.858.74-11.858s2.965-5.93 1.483-10.376-2.965-5.188-2.965-5.188zM404.45 467.887l1.482 2.223s2.223 2.223.74 3.706a28.966 28.966 0 00-2.964 3.705s-8.152 2.224-8.152-.74v-9.636z",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.778,
    cy: 288.795,
    r: 9.824,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M395.185 291.867l-.741 14.082 13.34.741-.741-14.082-11.858-.741z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M409.637 307.06l-2.104-5.14s-9.754-3.753-12.718-.048l-1.483 4.447-11.858-2.964-6.67 14.822 5.929 42.245s15.564 20.01 36.316.741l5.929-40.021-4.447-15.564z",
    fill: "#575a89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#575a89",
    d: "M417.049 308.543l1.482-2.965 14.823-8.894 9.046-26.777 7 3-7.894 31.93-21.493 20.01-2.964-16.304zM382.956 304.837l-1.482-1.482-15.564-9.635-11.117-22.234-8.893 2.964 9.634 27.422 23.717 19.27 3.705-16.305z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M409.07 273.75l1.606-.803-2.41-.803v-.803s-12.047-4.819-13.653 3.212a16.143 16.143 0 000 19.276v2.41l12.85 1.606 1.607-4.82s8.031-14.456 0-19.275z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M284.187 90.907h176v101h-176z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M808.202 291.234l.816-5.26s4.753-10.805.996-11.388-6.891 9.704-6.891 9.704l1.375 10.986z",
    fill: "#ffb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#575a89",
    d: "M846.67 321.051l-33.581-6.745-3.902-24.459-9.885-.763.483 31.623 29.177 15.297 17.708-14.953z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M846.67 321.051l-33.581-6.745-3.902-24.459-9.885-.763.483 31.623 29.177 15.297 17.708-14.953z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6841f",
    d: "M858.377 284.764H755.313v-8.053h103.064z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M801.641 289.43l.007-5.322s3.056-11.402-.746-11.407-5.336 10.639-5.336 10.639l3.028 10.649z",
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M845.353 304.675l4.608-1.123a11.862 11.862 0 0011.641-14.211 15.504 15.504 0 00-15.484-15.524 15.504 15.504 0 00-15.524 15.485 12.32 12.32 0 0014.76 15.373zM818.254 381.458l3.751 41.066 6.792 40.309 11.406.014-1.471-39.542-6.023-47.912-14.455 6.065z",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M830.321 460.554l-7.61 4.552s-12.168 1.506-9.891 5.31 28.893 1.558 28.894.037-.748-9.886-2.268-9.888zM851.922 377.91s-.214 5.871-5.548 14.99l.725 28.135 27.33 35.012-9.895 8.352-33.41-38.062-8.307-45.634 10.66-10.632z",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M872.148 456.044s9.123 1.532 7.597 5.332-5.35 21.284-15.231 18.99c0 0-4.563-.005-3.038-3.045a55.004 55.004 0 013.048-5.319l.013-9.885z",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.415,
    cy: 294.041,
    r: 11.406,
    fill: "#ffb8b8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M845.728 301.652l-.016 12.926-12.166-.015 1.537-12.924 10.645.013z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M830.51 309.997l3.687-.906 11.52.925s6.076 6.09 5.314 7.61-4.611 38.775-4.611 38.775l6.81 26.622-24.334 1.49-12.164-1.536 2.34-47.902s-5.306-12.933 1.543-16.726a29.954 29.954 0 009.895-8.352z",
    fill: "#575a89"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#575a89",
    d: "M844.193 313.056l-34.215-1.564-7.574-23.581-9.886.747 5.283 31.183 31.163 10.685 15.229-17.47z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.432,
    cy: 278.279,
    r: 7.359,
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M855.643 274.323a7.355 7.355 0 018.807-7.204 7.355 7.355 0 10-4.588 13.862 7.353 7.353 0 01-4.22-6.658zM849.33 278.497l-9.921-1.827-7.63 4.782a11.573 11.573 0 00-5.331 11.295l7.641-1.937 1.711-4.29 2.038 3.34 8.267 14.454 8.37-4.552 5.333-8.358z",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M283.69 91.775l.995-1.735 176 101-.996 1.735z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M283.686 191.033L459.694 90.047l.995 1.735-176.008 100.986zM692.48 139.614l1.414-1.414 57 57-1.414 1.414z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M692.48 195.2l57-57 1.414 1.414-57 57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWorkTogetherH63L);
export default __webpack_public_path__ + "static/media/undraw_work_together_h63l.78531c9d963c640ce14d4ca6a3741a76.svg";
export { ForwardRef as ReactComponent };